import React from 'react'
import { WidgetGuard } from 'features/types'
import {
  TopicInaccessibleGuard,
  UnexpectedServiceErrorGuard,
  TopicLanguageNotSupportedGuard,
  TopicIndexNotReadyGuard,
  WidgetLoadingGuard
} from 'components/widget/share/guards'
import ChannelsEmptyResultGuard from './ChannelsEmptyResultGuard'

const PostSearchDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <WidgetLoadingGuard widgetId={widgetId}>
    <TopicInaccessibleGuard widgetId={widgetId}>
      <UnexpectedServiceErrorGuard widgetId={widgetId}>
        <TopicLanguageNotSupportedGuard widgetId={widgetId}>
          <TopicIndexNotReadyGuard widgetId={widgetId}>
            <ChannelsEmptyResultGuard widgetId={widgetId}>{children}</ChannelsEmptyResultGuard>
          </TopicIndexNotReadyGuard>
        </TopicLanguageNotSupportedGuard>
      </UnexpectedServiceErrorGuard>
    </TopicInaccessibleGuard>
  </WidgetLoadingGuard>
)

export default PostSearchDataGuards
